"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Check_1 = require("../check/Check");
function isCompanyFile(object) {
    return checkCompanyFile(object).fulfilled;
}
exports.isCompanyFile = isCompanyFile;
function checkCompanyFile(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return Check_1.check(object, Check_1.hasString("id"), Check_1.hasString("name"), Check_1.hasString("companyId"), Check_1.hasString("folderId").optional().nullable(), Check_1.hasNumber("size").optional().nullable(), Check_1.hasChoice("type", ["IMAGE", "VIDEO", "AUDIO", "DOCUMENT", "FOLDER"]).optional().nullable()).withOptions(options).explain();
}
exports.checkCompanyFile = checkCompanyFile;
//# sourceMappingURL=CompanyFile.js.map